import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { DashboardPage } from "@/features/dashboard/pages/dashboard-page";

export const Route = createFileRoute("/_authenticated/admin/")({
	head: () => pageTitle("Dashboard"),
	component: DashboardPage,
});
